var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrokenBookmark = function SvgBrokenBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#87899F",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 10.75V7a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v13.168a1 1 0 0 1-1.54.841l-4.379-2.814a2 2 0 0 0-2.162 0L6.54 21.01A1 1 0 0 1 5 20.17V15.25"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9 8.5h6"
  }))));
};
export default SvgBrokenBookmark;